/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { ChatInputComponent } from './chatInput/chatInput/chatInput.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { dataChatService } from 'src/chatbot/service/dataChat.service';
import { RequestService } from 'src/chatbot/service/request.service';
import { SendButtonComponent } from './buttons/sendButton/sendButton/sendButton.component';
import { CancelButtonComponent } from './buttons/cancelButton/cancelButton.component';
import { SendMessageService } from 'src/chatbot/service/sendMessage.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InfoIconComponent } from 'src/chatbot/icons/info-icon.component';
import { LinkIconComponent } from 'src/chatbot/icons/link-icon.component';
import { VoiceButtonComponent } from './buttons/voiceButton/voiceButton.component';
import { ModalController } from '@ionic/angular';
import { ChatBotInfoComponent } from '../chatBotInfo/chatBotInfo.component';
import { RecordAudioHandlerService } from 'src/chatbot/service/recordAudioHandler.service';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'chat-input-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ChatInputComponent,
    SendButtonComponent,
    CancelButtonComponent,
    InfoIconComponent,
    LinkIconComponent,
    VoiceButtonComponent
  ],
  templateUrl: './chatInputForm.component.html',
  styleUrl: './chatInputForm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ChatInputFormComponent {
  @ViewChild('waveformCanvas', { static: true }) waveformCanvas!: ElementRef<HTMLCanvasElement>;
  private webSocketService = inject(WebSocketService)
  private recordService = inject(RecordAudioHandlerService);
  private toolsService = inject(ToolsService);

  public fb = inject(FormBuilder);
  public dataChat = inject(dataChatService);
  public request = inject(RequestService);
  private modalController = inject(ModalController);
  public sendMessage = inject(SendMessageService);
  
  public isRecording = computed(() => this.recordService.isRecording());
  public isStreaming = computed(() => this.dataChat.isStreaming());
  public showRecordIcon = computed(() => this.recordService.showRecordIcon());
  public typeChat = computed(() => this.toolsService.chatType());
  
  public chatForm: FormGroup;
  private modal: any;

  constructor(){
    this.chatForm = this.fb.group({
      userInput: ['', Validators.required],
    })
  }

  onEnterKey(event: Event){
    if(this.dataChat.isStreaming()){
      event.preventDefault();
      return;
    }
  }

  handleSubmit() {
    this.sendMessage.sendMessageWebSocket(this.chatForm.value.userInput);
    this.chatForm.reset();
    this.dataChat.inputText.set(null)
  }

  async openModal() {
    if (this.modal) 
      return;

    this.modal = await this.modalController.create({
      component: ChatBotInfoComponent,
      cssClass: ['chatBotModal', 'ion-disable-focus-trap'],
      componentProps: {},
    });
    await this.modal.present();
    await this.modal.onDidDismiss();
    this.modal = null;
  }

  goToiUrban(){
    window.open('https://iurban.es/', "_blank");
  }

  handleStart(){
    const waves = this.waveformCanvas?.nativeElement;
    this.recordService.startRecording(waves);
    // this.recordService.handleRecord(waves);
    // this.recordService.startRecording(waves);
  }

  getCanvasWidth(form){
    return form.offsetWidth - 100;
  }

  handleReceivedData(event){
    switch(event){
      case 'START': 
        this.handleStart();
        break;
      case 'STOP': 
        this.handleRecordingStop();
        break;
    }
  }

  handleStreamingStop(){
    this.webSocketService.cancelCompletion();
  }

  handleRecordingStop(){
    this.webSocketService.enableLoader();
    this.recordService.stopRecording()
  }

}
